import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';
var state = {
    status: null,
    loading: false,
};
export var jobPortal = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
};
